import { Label } from "@tql/ui-components-react/kendo/labels";

import { AccessorialServicesList } from "~/features/quote/components/quote-details/components/additional-details/accessorial-services-list.tsx";
import { CustomerReferencesSection } from "~/features/quote/components/shipment-details/components/additional-details-section/customer-references-section.tsx";

import tenderLtlStyles from "../../index.module.css";
import styles from "./tender-additional-details.module.css";

type TenderAdditionalDetailsProps = {
	readonly isRepairMode?: boolean;
	readonly hasFieldError?: (field: string) => boolean;
	readonly onClearFieldError?: (field: string) => void;
};

export const TenderAdditionalDetails = ({
	isRepairMode = false,
	hasFieldError,
	onClearFieldError,
}: TenderAdditionalDetailsProps = {}) => {
	return (
		<div
			className={`${styles.tenderAdditionalDetailsWrapper} ${tenderLtlStyles.tenderLtlCard}`}
		>
			<h4>Additional Details</h4>
			<Label>Accessorial Services</Label>
			<AccessorialServicesList disabled={isRepairMode} />
			<CustomerReferencesSection
				ignoreShipmentValueFlag
				hasFieldError={hasFieldError}
				onClearFieldError={onClearFieldError}
				shipmentValueReadOnly={isRepairMode}
			/>
		</div>
	);
};
